import { EmployerStaffRole, UserStatus } from 'src/api';

export const FormFields = {
  userStatus: 'userStatus',
  businessRole: 'businessRole',
} as const;

export type FormValues = {
  [FormFields.userStatus]: UserStatus;
  [FormFields.businessRole]: EmployerStaffRole;
};
